(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('samago-similar-products')) {
    customElements.define('samago-similar-products', class extends HTMLElement {
      connectedCallback() {
        const norm = (value) => (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/gi, '').toLowerCase();
        const vendors = new URLSearchParams(window.location.search).getAll('filter.p.vendor');
        if (!vendors.length) return;
        const map = {};
        (this.dataset.map || '').split(/\n/).forEach((line) => {
          const at = line.lastIndexOf(':');
          if (at > 0) map[norm(line.slice(0, at))] = line.slice(at + 1).trim();
        });
        const match = vendors.map((vendor) => map[norm(vendor)]).find(Boolean);
        const handle = match || this.dataset.fallback || 'all';
        const base = (this.dataset.base || '/collections').replace(/\/$/, '');
        const url = `${base}/${encodeURIComponent(handle)}?sort_by=best-selling&section_id=samago-similar-products`;
        fetch(url)
          .then((response) => (response.ok ? response.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = doc.querySelector('[data-similar-products-grid]');
            if (!this.isConnected || !grid || !grid.children.length) return;
            grid.classList.add(`grid--${this.dataset.columns || 3}-col-desktop`);
            this.querySelector('[data-similar-grid]').replaceChildren(grid);
            this.hidden = false;
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samago-home-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('samago-home-brands')) {
    customElements.define('samago-home-brands', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.viewport = this.querySelector('.samago-home-brands__viewport');
        this.list = this.querySelector('.samago-home-brands__list');
        if (!this.viewport || !this.list.children.length) return;
        this.updateBrandLinks();
        this.copy = this.list.cloneNode(true);
        this.copy.setAttribute('aria-hidden', 'true');
        this.copy.removeAttribute('aria-labelledby');
        this.copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
        this.copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
        this.list.after(this.copy);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true';
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.held = false;
        this.position = 0;
        this.previousTime = 0;
        this.frame = null;
        this.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { this.hovered = true; this.sync(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.sync(); }, options);
        this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); this.sync(); }); }, options);
        this.viewport.addEventListener('pointerdown', () => { this.held = true; this.sync(); }, options);
        const release = () => { if (this.held && !this.touching) { this.held = false; this.resumeAt = performance.now() + 1000; this.sync(); } };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.viewport.addEventListener('touchstart', event => {
          this.touching = true;
          this.held = true;
          this.touchedLink = event.target.closest('.samago-home-brands__link');
          this.touchedLink?.classList.add('is-touched');
          this.sync();
        }, { ...options, passive: true });
        const releaseTouch = event => {
          if (event.touches.length) return;
          this.touching = false;
          this.touchedLink?.classList.remove('is-touched');
          this.touchedLink = null;
          release();
        };
        window.addEventListener('touchend', releaseTouch, options);
        window.addEventListener('touchcancel', releaseTouch, options);
        this.viewport.addEventListener('wheel', () => { this.resumeAt = performance.now() + 1000; }, { ...options, passive: true });
        this.viewport.addEventListener('scroll', () => {
          if (!this.frame || performance.now() < (this.resumeAt || 0)) {
            this.position = this.viewport.scrollLeft;
            if (!this.held) this.resumeAt = performance.now() + 1000;
          }
        }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.resize = new ResizeObserver(() => { this.cycle = this.list.getBoundingClientRect().width; this.position = this.viewport.scrollLeft; this.sync(); });
        this.resize.observe(this.list);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) { this.paused = true; event.target.scrollIntoView({ block: 'nearest', inline: 'center' }); this.sync(); }
        }, options);
        this.tick = time => {
          this.frame = null;
          if (!this.running()) return;
          if (time < (this.resumeAt || 0)) {
            this.position = this.viewport.scrollLeft;
            this.previousTime = time;
          } else {
            const delta = this.previousTime ? Math.min(time - this.previousTime, 50) : 0;
            this.previousTime = time;
            this.position = (this.position + Number(this.dataset.speed || 28) * delta / 1000) % this.cycle;
            this.viewport.scrollLeft = this.position;
          }
          this.frame = requestAnimationFrame(this.tick);
        };
        this.sync();
      }
      normalizeVendor(value) {
        return value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
      }
      matchingVendors(vendor, aliases, catalog) {
        const names = [vendor, ...aliases.split('|')].map(name => this.normalizeVendor(name.trim())).filter(Boolean);
        const accepted = new Set(names);
        return [...new Set(catalog.filter(name => typeof name === 'string' && accepted.has(this.normalizeVendor(name))))];
      }
      updateBrandLinks() {
        const source = this.querySelector('[data-brand-vendors]');
        if (!source) return;
        let vendors;
        try { vendors = JSON.parse(source.textContent); } catch { return; }
        if (!Array.isArray(vendors)) return;
        this.list.querySelectorAll('[data-brand-vendor]').forEach(link => {
          const url = new URL(link.href, window.location.origin);
          if (url.origin !== window.location.origin || !url.searchParams.has('filter.p.vendor')) return;
          const matches = this.matchingVendors(link.dataset.brandVendor, link.dataset.brandAliases || '', vendors);
          if (!matches.length) return;
          url.searchParams.delete('filter.p.vendor');
          matches.forEach(vendor => url.searchParams.append('filter.p.vendor', vendor));
          link.setAttribute('href', url.pathname + url.search + url.hash);
        });
      }
      running() { return this.isConnected && this.cycle > this.viewport.clientWidth && this.visible && !document.hidden && !this.paused && !this.motion.matches && !this.hovered && !this.focused && !this.held; }
      sync() {
        if (!this.running()) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
          this.previousTime = 0;
        } else if (!this.frame && this.tick) {
          this.position = this.viewport.scrollLeft;
          this.frame = requestAnimationFrame(this.tick);
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.copy?.remove();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samago-purchase-ideas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('samago-purchase-ideas')) {
    customElements.define('samago-purchase-ideas', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.rail = this.querySelector('.samago-ideas__rail');
        this.scene = this.querySelector('.samago-ideas__scene');
        this.cards = [...this.querySelectorAll('.samago-ideas__slide')];
        this.originalCards = this.cards;
        this.mobileInitialized = false;
        this.touchHeld = false;
        this.pointerHeld = false;
        this.slider = this.querySelector('slider-component');
        if (!this.cards.length) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 750px)');
        this.animations = [];
        this.configureMobile();
        this.measure();
        if (this.desktop.matches && !this.motion.matches && this.cards[0].animate && !window.Shopify?.designMode) {
          // Pila centrada: cada card parte del centro del riel, la del medio queda arriba y las laterales se inclinan hacia su lado.
          const railRect = this.rail.getBoundingClientRect();
          const center = railRect.left + railRect.width / 2;
          const middle = (this.cards.length - 1) / 2;
          this.cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const side = index - middle;
            card.style.setProperty('--ideas-enter-x', `${center - (rect.left + rect.width / 2)}px`);
            card.style.setProperty('--ideas-enter-angle', `${Math.max(-7, Math.min(7, side * 1.75))}deg`);
            card.style.setProperty('--ideas-layer', this.cards.length - Math.round(Math.abs(side) * 2));
          });
          this.dataset.state = 'waiting';
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.reveal();
          }, { threshold: .2 });
          this.observer.observe(this);
        } else {
          this.dataset.state = 'settled';
        }
        this.syncFocus();
        this.rail.addEventListener('scroll', () => {
          this.nativeScrolling = true;
          if (!this.isCentering && !this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.syncFocus(); });
          this.scheduleLoop();
        }, { ...options, passive: true });
        this.rail.addEventListener('scrollend', () => { this.nativeScrolling = false; this.finishMobileScroll(); }, options);
        this.rail.addEventListener('touchstart', () => { this.touchHeld = true; this.cancelMobileCenter(); }, { ...options, passive: true });
        ['touchend', 'touchcancel'].forEach(type => this.rail.addEventListener(type, event => {
          this.touchHeld = event.touches.length > 0;
          if (!this.touchHeld) {
            this.scheduleLoop();
            if (!this.nativeScrolling) this.finishMobileScroll();
          }
        }, { ...options, passive: true }));
        this.addEventListener('pointerdown', () => { this.pointerHeld = true; this.cancelMobileCenter(); this.settle(); }, options);
        ['pointerup', 'pointercancel'].forEach(type => this.addEventListener(type, () => {
          this.pointerHeld = false;
          this.scheduleLoop();
          if (!this.nativeScrolling) this.finishMobileScroll();
        }, options));
        this.addEventListener('keydown', event => {
          if (this.desktop.matches || !event.target.closest('.samago-ideas__card') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.mobileKeyboardFocus = true;
          const index = this.cards.indexOf(this.mobileActive) + (event.key === 'ArrowRight' ? 1 : -1);
          const card = this.cards[index];
          if (card) this.centerMobile(card, this.motion.matches ? 'instant' : 'smooth');
          if (!this.isCentering) this.finishMobileScroll();
        }, options);
        this.addEventListener('focusin', event => {
          this.settle();
          const card = event.target.closest('.samago-ideas__slide');
          if (card && (this.desktop.matches || event.target.matches(':focus-visible'))) {
            if (this.desktop.matches) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
            else this.centerMobile(card);
          }
          this.syncFocus();
        }, options);
        this.addEventListener('click', event => {
          if (this.desktop.matches) return;
          const card = event.target.closest('.samago-ideas__slide');
          if (card && !card.classList.contains('is-current')) {
            event.preventDefault();
            this.centerMobile(card, this.motion.matches ? 'instant' : 'smooth');
          }
        }, options);
        this.motion.addEventListener('change', () => { this.settle(); this.measure(); }, options);
        this.desktop.addEventListener('change', () => { this.configureMobile(); this.settle(); this.measure(); }, options);
        this.resize = new ResizeObserver(() => {
          if (this.lastWidth !== undefined && Math.abs(this.lastWidth - this.rail.clientWidth) > 1) {
            if (!this.desktop.matches && this.mobileActive) this.centerMobile(this.mobileActive);
            this.settle();
          }
          this.lastWidth = this.rail.clientWidth;
          this.measure();
          this.syncFocus();
        });
        this.resize.observe(this.rail);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            this.settle();
            event.target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
          }
        }, options);
      }
      measure() {
        if (!this.desktop.matches) {
          this.style.removeProperty('--ideas-overlap');
          this.mobileGeometry = null;
          return;
        }
        const card = this.cards[0];
        this.style.setProperty('--ideas-overlap', `${this.slider.offsetTop + card.offsetTop + card.offsetHeight / 2}px`);
      }
      reveal() {
        if (this.dataset.state !== 'waiting') return;
        this.observer?.disconnect();
        const transforms = this.cards.map(card => getComputedStyle(card).transform);
        this.dataset.state = 'opening';
        this.setAttribute('aria-busy', 'true');
        // Apertura simultánea desde el centro, con la misma duración y curva que "¿Por qué es tan barato?" (900 ms, cubic-bezier(.22,1,.36,1)).
        const middle = (this.cards.length - 1) / 2;
        this.animations = this.cards.map((card, index) => {
          const duration = 900;
          const delay = Math.round(Math.abs(index - middle) * 40);
          return card.animate([
            { transform: transforms[index], opacity: 1, offset: 0 },
            { transform: 'translateX(0) rotate(0)', opacity: 1, offset: 1 }
          ], { duration, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
        });
        Promise.allSettled(this.animations.map(animation => animation.finished)).then(() => {
          if (this.isConnected) this.settle();
        });
      }
      settle() {
        this.observer?.disconnect();
        this.dataset.state = 'settled';
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        this.removeAttribute('aria-busy');
        this.syncFocus();
      }
      configureMobile() {
        clearTimeout(this.loopTimer);
        this.cancelMobileCenter();
        this.mobileGeometry = null;
        if (this.desktop.matches) {
          this.cards.filter(card => !this.originalCards.includes(card)).forEach(card => card.remove());
          this.cards = this.originalCards;
          this.cards.forEach(card => card.querySelector('a').removeAttribute('tabindex'));
          this.mobileInitialized = false;
          this.rail.scrollTo({ left: 0, behavior: 'instant' });
        } else if (this.cards.length === this.originalCards.length && this.originalCards.length > 1) {
          ['before', 'after'].forEach(copy => {
            const fragment = document.createDocumentFragment();
            this.originalCards.forEach(card => {
              const clone = card.cloneNode(true);
              [clone, ...clone.querySelectorAll('[id]')].forEach(node => { node.id += `-${copy}`; });
              clone.querySelectorAll('[aria-labelledby]').forEach(node => {
                node.setAttribute('aria-labelledby', node.getAttribute('aria-labelledby').split(' ').map(id => `${id}-${copy}`).join(' '));
              });
              clone.removeAttribute('data-shopify-editor-block');
              clone.inert = true;
              fragment.append(clone);
            });
            if (copy === 'before') this.scene.prepend(fragment);
            else this.scene.append(fragment);
          });
          this.cards = [...this.rail.querySelectorAll('.samago-ideas__slide')];
        }
        this.style.setProperty('--ideas-rendered-count', this.cards.length);
        this.slider.enableSliderLooping = !this.desktop.matches;
        this.slider.resetPages?.();
      }
      scheduleLoop() {
        clearTimeout(this.loopTimer);
        if (!this.desktop.matches && !('onscrollend' in this.rail)) this.loopTimer = setTimeout(() => this.finishMobileScroll(), 150);
      }
      finishMobileScroll() {
        if (this.desktop.matches || this.pointerHeld || this.touchHeld || this.isCentering) return;
        this.syncFocus();
        if (!this.mobileActive) return;
        const viewport = this.rail.getBoundingClientRect();
        const rect = this.mobileActive.getBoundingClientRect();
        const offset = rect.left + rect.width / 2 - (viewport.left + viewport.right) / 2;
        if (Math.abs(offset) > .75) {
          this.centerMobile(this.mobileActive, this.motion.matches ? 'instant' : 'smooth');
          if (this.isCentering) return;
          this.syncFocus();
        }
        this.normalizeMobile();
      }
      cancelMobileCenter() {
        cancelAnimationFrame(this.centerFrame);
        this.centerFrame = null;
        this.isCentering = false;
        delete this.dataset.centering;
      }
      normalizeMobile() {
        clearTimeout(this.loopTimer);
        if (this.desktop.matches || this.pointerHeld || this.touchHeld || this.isCentering || !this.mobileActive) return;
        const index = this.cards.indexOf(this.mobileActive);
        const original = this.originalCards[index % this.originalCards.length];
        const focused = this.mobileActive.contains(document.activeElement);
        if (original !== this.mobileActive) {
          this.dataset.loopReset = 'true';
          this.rail.scrollTo({ left: this.rail.scrollLeft + original.offsetLeft - this.mobileActive.offsetLeft, behavior: 'instant' });
          this.syncFocus();
          getComputedStyle(original.querySelector('a')).transform;
          this.loopFrame = requestAnimationFrame(() => { delete this.dataset.loopReset; });
        }
        if (focused || this.mobileKeyboardFocus) {
          this.mobileKeyboardFocus = false;
          original.querySelector('a').focus({ preventScroll: true });
        }
      }
      syncMobile() {
        if (this.desktop?.matches !== false) return;
        if (!this.mobileInitialized && this.rail.clientWidth) {
          this.mobileInitialized = true;
          this.centerMobile(this.originalCards[0]);
        }
        if (!this.mobileGeometry) {
          const viewport = this.rail.getBoundingClientRect();
          const first = this.cards[0].getBoundingClientRect();
          this.mobileGeometry = {
            start: first.left + first.width / 2 - (viewport.left + viewport.right) / 2 + this.rail.scrollLeft,
            step: this.cards[1] ? this.cards[1].getBoundingClientRect().left - first.left : first.width,
            cardWidth: first.width,
            halfWidth: (viewport.right - viewport.left) / 2
          };
        }
        const { start, step, cardWidth, halfWidth } = this.mobileGeometry;
        if (!step) return;
        const position = (this.rail.scrollLeft - start) / step;
        const distances = this.cards.map((card, index) => index - position);
        const nearest = distances.reduce((best, distance, index) => Math.abs(distance) < Math.abs(distances[best]) ? index : best, 0);
        this.mobileActive = this.cards[nearest];
        this.cards.forEach((card, index) => {
          const distance = distances[index];
          const proximity = Math.max(0, 1 - Math.abs(distance));
          const approach = proximity * proximity * (3 - 2 * proximity);
          const depth = Math.min(1, Math.max(0, Math.abs(distance) - 1));
          const scale = .875 + .245 * approach - .2 * depth * depth * (3 - 2 * depth);
          const hidden = Math.abs(distance * step) - cardWidth * scale / 2 >= halfWidth;
          if (hidden && card.classList.contains('is-distant')) return;
          card.classList.toggle('is-current', index === nearest);
          card.classList.toggle('is-distant', hidden);
          card.style.setProperty('--ideas-mobile-layer', 10000 - Math.round(Math.abs(distance)));
          card.style.setProperty('--ideas-mobile-scale', scale);
          // Cover flow (referencia affectUI): la tarjeta sigue al dedo, las laterales giran hacia el centro y se van al fondo con un punto de fuga común.
          const turn = this.motion?.matches ? 0 : Math.min(1, Math.abs(distance));
          const side = Math.sign(distance);
          const flowX = side * (turn * .78 + Math.max(0, Math.abs(distance) - 1) * .27) * cardWidth - (this.motion?.matches ? 0 : distance * step);
          card.style.setProperty('--ideas-mobile-flow', turn ? `translate3d(${flowX.toFixed(2)}px, 0, ${(-turn * .7 * cardWidth).toFixed(2)}px) rotateY(${(-side * turn * 50).toFixed(2)}deg)` : 'translateZ(0)');
          card.style.setProperty('--ideas-mobile-origin', `${(cardWidth / 2 - distance * step).toFixed(2)}px`);
          const gray = Math.abs(distance) < .01 ? 0 : Math.abs(distance) > .99 ? 1 : Math.abs(distance);
          card.style.setProperty('--ideas-mobile-gray', gray);
          card.querySelector('a').tabIndex = index === nearest ? 0 : -1;
        });
        const previous = this.slider.querySelector('[name="previous"]');
        const next = this.slider.querySelector('[name="next"]');
        if (previous) previous.disabled = this.originalCards.length < 2;
        if (next) next.disabled = this.originalCards.length < 2;
      }
      centerMobile(card, behavior = 'instant') {
        this.cancelMobileCenter();
        const viewport = this.rail.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        const from = this.rail.scrollLeft;
        const to = from + rect.left + rect.width / 2 - (viewport.left + viewport.right) / 2;
        if (behavior !== 'smooth' || this.motion.matches || Math.abs(to - from) <= .75) {
          this.rail.scrollTo({ left: to, behavior: 'instant' });
          return;
        }
        this.isCentering = true;
        // Sin snap mientras el JS anima el scroll (tap/teclado), si no el snap mandatory corta cada cuadro.
        this.dataset.centering = 'true';
        const started = performance.now();
        const duration = Math.min(340, 240 + Math.abs(to - from) * .4);
        const move = now => {
          const progress = Math.min(1, (now - started) / duration);
          const eased = progress * progress * (3 - 2 * progress);
          this.rail.scrollTo({ left: from + (to - from) * eased, behavior: 'instant' });
          this.syncFocus();
          if (progress < 1) this.centerFrame = requestAnimationFrame(move);
          else {
            this.centerFrame = null;
            this.isCentering = false;
            delete this.dataset.centering;
            this.normalizeMobile();
          }
        };
        this.centerFrame = requestAnimationFrame(move);
      }
      syncFocus() {
        this.syncMobile();
        const mobile = this.desktop?.matches === false;
        const viewport = mobile ? null : this.rail.getBoundingClientRect();
        const opening = this.dataset.state !== 'settled';
        this.cards.forEach(card => {
          const rect = mobile ? null : card.getBoundingClientRect();
          const hidden = mobile ? card.classList.contains('is-distant') : rect.right <= viewport.left + 1 || rect.left >= viewport.right - 1;
          if (card.inert !== (opening || hidden)) card.inert = opening || hidden;
          if (hidden && !opening) {
            if (card.getAttribute('aria-hidden') !== 'true') card.setAttribute('aria-hidden', 'true');
          } else if (card.hasAttribute('aria-hidden')) card.removeAttribute('aria-hidden');
        });
      }
      disconnectedCallback() {
        clearTimeout(this.loopTimer);
        this.cancelMobileCenter();
        cancelAnimationFrame(this.loopFrame);
        cancelAnimationFrame(this.scrollFrame);
        delete this.dataset.loopReset;
        this.cards?.filter(card => !this.originalCards.includes(card)).forEach(card => card.remove());
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samago-why-cheap"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('samago-why-cheap-photos')) {
    customElements.define('samago-why-cheap-photos', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motionChanged = () => {
          if (this.motion.matches) this.reveal();
        };
        this.motion.addEventListener('change', this.motionChanged);
        this.slots = [...this.querySelectorAll('.samago-why-cheap__photo-slot')];
        if (this.motion.matches || !('IntersectionObserver' in window) || this.slots.length !== 3) {
          this.reveal();
          return;
        }
        this.measure();
        this.dataset.state = 'stacked';
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.measure());
          this.resize.observe(this);
        }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.reveal();
        }, { threshold: 0.3 });
        this.observer.observe(this);
      }

      measure() {
        const centerX = this.clientWidth / 2;
        const centerTop = this.slots[1].offsetTop;
        this.slots.forEach(slot => {
          slot.style.setProperty('--stack-x', `${centerX - slot.offsetLeft - slot.offsetWidth / 2}px`);
          slot.style.setProperty('--stack-y', `${centerTop - slot.offsetTop}px`);
        });
      }

      reveal() {
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.revealFrame = requestAnimationFrame(() => {
          this.dataset.state = 'spread';
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.revealFrame);
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.motion?.removeEventListener('change', this.motionChanged);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
